module.exports = __webpack_public_path__ + "static/media/dots.03417718.svg";